<template>
  <section>
    <div v-if="key.length > 0" style="display: flex; flex-direction: column; background: #f8f9fc;">
      <div v-if="isLogoVisible" style="display: flex; justify-content: left;">
        <img
          src="@/assets/icons/ic-system-viabus.svg"
          style="margin-top: 19px; margin-left: 16px;"
        />
      </div>
      <div
        v-if="!isCompletedChange"
        style="position: absolute; display: flex; align-items: center; width: 100%; height: 100%;"
        :style="{ marginTop: isLogoVisible ? '0' : '20px' }"
      >
        <div style="width: 100%; max-width: 480px; margin: auto;">
          <div class="title">{{ getI18nMessage('title') }}</div>
          <div class="input-title" style="margin-top: 50px;">
            {{ getI18nMessage('passwordLabel') }}
          </div>
          <div class="input-view" :class="isProcessing ? 'disabled' : ''">
            <input
              ref="passwordTextField"
              type="password"
              autocomplete="off"
              class="input-box"
              :placeholder="getI18nMessage('passwordPlaceholder')"
              v-model="password"
            />
            <div
              v-if="password.length > 0"
              class="toggle-button clickable"
              style="display: flex; align-items: center; margin-right: 8px; margin-left: 8px;"
              @click="togglePasswordVisibility"
            >
              {{ getPasswordVisibilityToggleTitle }}
            </div>
          </div>
          <div class="input-title" style="margin-top: 22px;">
            {{ getI18nMessage('confirmPasswordLabel') }}
          </div>
          <div class="input-view" :class="isProcessing ? 'disabled' : ''">
            <input
              ref="confirmPasswordTextField"
              type="password"
              autocomplete="off"
              class="input-box"
              :placeholder="getI18nMessage('confirmPasswordPlaceholder')"
              v-model="confirmPassword"
            />
            <div
              v-if="confirmPassword.length > 0"
              class="toggle-button clickable"
              style="display: flex; align-items: center; margin-right: 8px; margin-left: 8px;"
              @click="toggleConfirmPasswordVisibility"
            >
              {{ getConfirmPasswordVisibilityToggleTitle }}
            </div>
          </div>
          <div v-if="errorMessage.length > 0" class="error" style="margin-top: 4px;">
            {{ errorMessage }}
          </div>
          <div
            v-if="!isProcessing"
            class="set-password-button"
            :class="
              password.length > 0 && confirmPassword.length > 0
                ? 'button-enabled'
                : 'button-disabled'
            "
            @click="setPassword"
          >
            {{ getI18nMessage('setPassword') }}
          </div>
          <div v-else class="set-password-button button-loading">
            <div class="loader" style="overflow: hidden;">Loading...</div>
          </div>
        </div>
      </div>

      <div
        v-else
        style="position: absolute; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
      >
        <div
          style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12vh;"
        >
          <img src="@/assets/icons/icon-32-ic-done-oval.svg" />
          <div class="title-complete">{{ getI18nMessage('completedTitle') }}</div>
          <div class="description-complete">
            {{ getI18nMessage('completedDescription', isMobile ? 'mobile' : 'desktop') }}
          </div>
          <div
            v-if="isMobile"
            style="margin-top: 5vh;"
            class="filled-xl-button"
            @click="openViaBusApp"
          >
            {{ getI18nMessage('openViaBusApp') }}
          </div>
        </div>
      </div>
      <Footer v-if="isCompletedChange" :language="language"> </Footer>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import { getErrorPasswordValidation } from '@/utils/fieldValidation';
import { changePassword } from '@/services/userService';
import { isMobile } from '@/utils/useragent';
import Footer from '@/components/footer';

const i18n = {
  title: {
    th: 'ตั้งรหัสผ่านใหม่',
    en: 'Set New Password',
  },
  passwordLabel: {
    th: 'รหัสผ่านใหม่',
    en: 'New Password',
  },
  passwordPlaceholder: {
    th: 'อย่างน้อย 6 ตัวอักษร',
    en: 'At least 6 characters',
  },
  confirmPasswordLabel: {
    th: 'ยืนยันรหัสผ่านใหม่',
    en: 'Confirm New Password',
  },
  confirmPasswordPlaceholder: {
    th: 'ใส่รหัสผ่านใหม่อีกครั้ง',
    en: 'Enter your new password again',
  },
  show: {
    th: 'แสดง',
    en: 'Show',
  },
  hide: {
    th: 'ซ่อน',
    en: 'Hide',
  },
  setPassword: {
    th: 'ตั้งรหัสผ่าน',
    en: 'Set Password',
  },
  passwordMismatch: {
    th: 'รหัสผ่านไม่ตรงกัน',
    en: "Passwords don't match",
  },
  completedTitle: {
    th: 'ตั้งรหัสผ่านของคุณเรียบร้อย!',
    en: 'Your Password Set!',
  },
  cannotConnect: {
    th: 'มีบางอย่างขัดข้อง กรุณาส่งอีกครั้ง',
    en: 'Something went wrong, please try again',
  },
  openViaBusApp: {
    th: 'เปิดแอป ViaBus',
    en: 'Open ViaBus App',
  },
  mobile: {
    completedDescription: {
      th: 'คุณสามารถใช้รหัสผ่านใหม่\nในการเข้าสู่ระบบครั้งต่อไปได้แล้ว',
      en: 'You can now use the new password\non your next login.',
    },
  },
  desktop: {
    completedDescription: {
      th: 'คุณสามารถใช้รหัสผ่านใหม่ในการเข้าสู่ระบบครั้งต่อไปได้แล้ว',
      en: 'You can now use the new password on your next login.',
    },
  },
};

export default {
  components: { Footer },
  computed: {
    isMobile,
    getPasswordVisibilityToggleTitle() {
      if (!this.isPasswordVisible) {
        return this.getI18nMessage('show');
      } else {
        return this.getI18nMessage('hide');
      }
    },
    getConfirmPasswordVisibilityToggleTitle() {
      if (!this.isConfirmPasswordVisible) {
        return this.getI18nMessage('show');
      } else {
        return this.getI18nMessage('hide');
      }
    },
  },
  watch: {
    password() {
      if (this.errorMessage.length > 0) {
        this.errorMessage = '';
      }
    },
    confirmPassword() {
      if (this.errorMessage.length > 0) {
        this.errorMessage = '';
      }
    },
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      language: 'en',
      key: '',
      errorMessage: '',
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      isProcessing: false,
      isCompletedChange: false,
      isLogoVisible: true,
    };
  },
  methods: {
    getI18nMessage(key, platform) {
      return _.get(i18n, `${platform ? platform + '.' : ''}${key}.${this.language}`, '');
    },
    togglePasswordVisibility() {
      if (this.$refs.passwordTextField.type === 'password') {
        this.$refs.passwordTextField.type = 'text';
        this.isPasswordVisible = true;
      } else {
        this.$refs.passwordTextField.type = 'password';
        this.isPasswordVisible = false;
      }
      this.$refs.passwordTextField.focus();
    },
    toggleConfirmPasswordVisibility() {
      if (this.$refs.confirmPasswordTextField.type === 'password') {
        this.$refs.confirmPasswordTextField.type = 'text';
        this.isConfirmPasswordVisible = true;
      } else {
        this.$refs.confirmPasswordTextField.type = 'password';
        this.isConfirmPasswordVisible = false;
      }
      this.$refs.confirmPasswordTextField.focus();
    },
    setPassword() {
      this.errorMessage = '';
      if (this.password !== this.confirmPassword) {
        this.errorMessage = this.getI18nMessage('passwordMismatch');
        return;
      }
      const errorMessage = getErrorPasswordValidation(this.password, this.language);
      if (errorMessage) {
        this.errorMessage = errorMessage;
        return;
      }

      changePassword(this.password, this.key)
        .then(() => {
          this.isCompletedChange = true;
        })
        .catch(err => {
          this.errorMessage = _.get(
            err,
            'response.data.info',
            this.getI18nMessage('cannotConnect')
          );
        });
    },
    onWindowResize() {
      this.setLogoVisible();
    },
    setLogoVisible() {
      this.isLogoVisible = window.innerHeight > 480;
    },
    openViaBusApp() {
      location.href = 'co.viabus://link?action=open';
    },
  },
  mounted() {
    let lang = _.get(this.$route.query, 'lang', 'en').trim();
    if (lang === 'en' || lang === 'th') {
      this.language = lang;
    }
    this.key = _.get(this.$route.query, 'key', '').trim();

    if (!this.key) {
      this.$router.push({ name: 'LinkInvalid', query: this.$route.query });
    }

    this.setLogoVisible();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>

<style scoped>
@import '../css/spinner.css';

section {
  font-family: 'ViaNotoSans';
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #263373;
  margin-left: 16px;
  margin-top: 40px;
}

.description {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.47;
  color: #7a88b8;
  margin-top: 23px;
  margin-left: 16px;
  margin-right: 16px;
}

.input-title {
  font-size: 13px;
  font-weight: 500;
  color: #7a88b8;
  margin: 0 16px;
}

.input-box::placeholder {
  font-size: 15px;
  font-weight: 500;
  color: #9ca6c9;
}

.input-view {
  border-radius: 4px;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 12px;
  height: 48px;
  display: flex;
  align-items: center;
  background: #edeff7;
}

.input-box {
  width: 100%;
  height: 48px;
  border-radius: 4px;
  font-family: 'ViaNotoSans';
  font-size: 15px;
  font-weight: 500;
  color: #9ca6c9;
  background-color: #edeff7;
  border: 0;
  padding: 0 12px;
  color: #263373;
}

.set-password-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #dbe0f0;
  margin: 40px 16px;
  height: 48px;
}

.clickable {
  cursor: pointer;
  user-select: none;
}

.error {
  color: #ff335c;
  font-size: 13px;
  font-weight: 500;
  margin: 0 16px;
  white-space: pre-line;
}

.button-enabled {
  cursor: pointer;
  user-select: none;
  font-size: 17px;
  font-weight: 600;
  color: white;
  background-color: #4d6aff;
}

.button-disabled {
  font-size: 17px;
  font-weight: 600;
  pointer-events: none;
  color: #9ca6c9;
  background-color: #dbe0f0;
}

.toggle-button {
  font-size: 12px;
  font-weight: 500;
  color: #4d6aff;
}

.button-loading {
  pointer-events: none;
  background-color: #4d6aff;
  opacity: 0.8;
}

.disabled {
  pointer-events: none;
  opacity: 0.8;
}

.title-complete {
  font-size: 24px;
  font-weight: bold;
  color: #263373;
  text-align: center;
  margin-top: 24px;
  white-space: pre;
}

.description-complete {
  margin-top: 5vh;
  font-size: 15px;
  font-weight: 500;
  color: #263373;
  margin-left: 16px;
  margin-right: 16px;
  text-align: center;
  white-space: pre;
}
</style>
